import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { Observable } from 'rxjs';
import { StateService } from './state.service';
import { LoggerService } from '../services/common/logger.service';

export interface ThemeState {
  darkMode: boolean;
}

const initialThemeState: ThemeState = {
  darkMode: false,
};

@Injectable({ providedIn: 'root' })
export class ThemeStateService extends StateService<ThemeState> {
  constructor(@Inject(PLATFORM_ID) platformId: Object, logger: LoggerService) {
    super(initialThemeState, platformId, logger);
  }

  selectDarkMode(): Observable<boolean> {
    return this.select(state => state.darkMode);
  }

  setDarkMode(isDark: boolean): void {
    this.setState({ darkMode: isDark });
  }

  toggle(): void {
    this.updateState(s => ({ darkMode: !s.darkMode }));
  }
}
